import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-tick-icon',
    templateUrl: './tick-icon.component.html',
    styleUrls: ['./tick-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TickIconComponent{
    @Input() creatorData: any;
    @Input() cls: string = '';
}